/**
 * Quiz question count for onboarding messaging.
 * Update when adding/removing steps in OnboardingWizard.
 * Should match OnboardingWizard steps array length.
 */
export const ONBOARDING_QUESTION_COUNT = 12;
